import React from "react"
import styled from "styled-components"

const StyledLabel = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: initial;
`

const FlexRow = styled.div`
  align-items: center;
  display: flex;
`

const SelectOption = ({
  innerRef,
  innerProps,
  data,
  selectProps,
  label
}: {
  innerRef: any
  innerProps: any
  data: any
  selectProps: any
  label: string
}) => {
  const {
    components: {OptionIcon, OptionLabel},
    labelKey
  } = selectProps

  return (
    <FlexRow ref={innerRef} {...innerProps}>
      {OptionIcon && <OptionIcon {...data} />}
      <StyledLabel>{OptionLabel ? <OptionLabel {...data} /> : label || data[labelKey]}</StyledLabel>
    </FlexRow>
  )
}

export default SelectOption
